import { RecoverBookingReferenceModal } from '@/components/RecoverBookingReferenceModal/RecoverBookingReferenceModal';
import { useRecoverBookingReferenceModal } from '@/components/RecoverBookingReferenceModal/useRecoverBookingReferenceModal';

import styles from './BookSkiPass.module.css';
import { useBookSkiPassForm } from './useBookSkiPassForm';

export const BookSkiPassForm = () => {
  const { stepOneFormFieldsValues, isLoading, error, handleChange, handleSubmit } =
    useBookSkiPassForm();
  const recoverModal = useRecoverBookingReferenceModal();

  return (
    <>
      <form
        className={styles.formWrapper}
        onSubmit={(event) => {
          void handleSubmit(event);
        }}
      >
        {error && <p className={styles.error}>{error}</p>}
        <div className={styles.formRow}>
          <div className={styles.inputsGroup}>
            <div className={styles.inputWrapper}>
              <label className={styles.inputLabel} htmlFor="bookingReference">
                Your booking reference
              </label>
              <input
                id="bookingReference"
                className={styles.formInput}
                name="bookingReference"
                placeholder="Add your reference"
                value={stepOneFormFieldsValues.bookingReference}
                onChange={handleChange}
              />
            </div>
            <div className={styles.inputWrapper}>
              <label className={styles.inputLabel} htmlFor="promoCode">
                Promo code
              </label>
              <input
                id="promoCode"
                className={styles.formInput}
                name="promoCode"
                placeholder="Add promo code"
                value={stepOneFormFieldsValues.promoCode}
                onChange={handleChange}
              />
            </div>
          </div>
          <button className={styles.submitButton} type="submit" disabled={isLoading}>
            {isLoading ? 'Loading...' : 'Book ski pass'}
          </button>
        </div>
        <p className={styles.helperText}>
          Forget your booking reference?{' '}
          <button
            type="button"
            className={styles.helperButton}
            onClick={recoverModal.open}
          >
            Click here
          </button>
        </p>
      </form>
      <RecoverBookingReferenceModal
        isOpen={recoverModal.isOpen}
        email={recoverModal.email}
        error={recoverModal.error}
        onClose={recoverModal.close}
        onEmailChange={recoverModal.setEmail}
        onSubmit={recoverModal.submit}
      />
    </>
  );
};
